<template>
    <section class="Section Hero">
        <div class="loader loaderPageDetails" v-show="this.isLoading"></div> 
            <div class="owl-carousel owl-theme HeroIkarus">
            <div v-for="slide in this.slides" :key="slide.IdElemento">
                <img class="LandscapeImage" :src="this.getFullImgUrl(slide.UrlImmagine)" alt="" />
                <img class="PortraitImage" :src="this.getFullImgUrl(slide.UrlImmagineMobile)" alt="" />
                <div class="Container">
                    <div class="Box">
                        <div class="HeroText">
                            <div class="Index">{{ slide.TestoLista }}</div>
                            <h1>{{ slide.Titolo }}</h1>
                            <div class="Button CustomColor Big">
                                <a :href="slide.Link">{{ slide.TitoloLista }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import ElementiInListaService from '@/services/elementiInLista.service.js';

const baseUrl = process.env.VUE_APP_BASEMEDIA_URL;

export default {
    name: "HeroSlider",
    data(){
        return {
            slides: [],
            isLoading: false
        }
    },    
    methods:{
        getFullImgUrl: function(imgUrl){
            return baseUrl + imgUrl
        }
    },
    props:{
        tipoElemento: String
    },
    created: function(){
        this.isLoading = true;
        ElementiInListaService.filterElementiInLista(this.$store.getters.getToken, this.$store.getters.getLingua, this.tipoElemento).then(
            (data) => {
                if(!data){
                    this.$router.push("/");
                }
                else{
                    this.slides = data;  
                    $(document).ready(function() {
                        $(".HeroIkarus").owlCarousel({
                            items: 1,
                            loop: true,
                            nav:true,
                            autoplay: true,
                            autoplayTimeout: 6000,
                            animateOut: 'fadeOut',
                            animateIn: 'fadeIn',
                            autoplayHoverPause: true
                        });
                    })
                    this.isLoading = false;
                    
                }
            }
        );

    }
}
</script>